import axios from 'axios';
import { FIELDS_ROOT, PAGES_ROOT } from '../../config/api';

const fieldActions = {
  ATOMICFI_GET_TOKEN: 'FIELD_ATOMICFI_GET_TOKEN',
  ATOMICFI_GET_TOKEN_FAILED: 'FIELD_ATOMICFI_GET_TOKEN_FAILED',
  ATOMICFI_GET_TOKEN_SUCCESS: 'FIELD_ATOMICFI_GET_TOKEN_SUCCESS',
  ATOMICFI_UPDATE_SWITCH_ATTEMPTS: 'ATOMICFI_UPDATE_SWITCH_ATTEMPTS',
  BLUR: 'FIELD_BLUR',
  FETCH_AUTOCOMPLETE: 'FIELD_FETCH_AUTOCOMPLETE',
  FETCH_AUTOCOMPLETE_SUCCESS: 'FIELD_FETCH_AUTOCOMPLETE_SUCCESS',
  GOOGLE_PLACES_AUTOCOMPLETE: 'FIELD_GOOGLE_PLACES_AUTOCOMPLETE',
  GOOGLE_PLACES_AUTOCOMPLETE_FAILED: 'FIELD_GOOGLE_PLACES_AUTOCOMPLETE_FAILED',
  GOOGLE_PLACES_AUTOCOMPLETE_SUCCESS: 'FIELD_GOOGLE_PLACES_AUTOCOMPLETE_SUCCESS',
  RERENDER: 'FIELD_RERENDER',
  RERENDER_FAILED: 'FIELD_RERENDER_FAILED',
  RERENDER_SUCCESS: 'FIELD_RERENDER_SUCCESS',
  SET_ERROR: 'FIELD_SET_ERROR',
  SET_FOCUS: 'FIELD_SET_FOCUS',
  SOCURE_AUTOCOMPLETE: 'FIELD_SOCURE_AUTOCOMPLETE',
  SOCURE_AUTOCOMPLETE_FAILED: 'FIELD_SOCURE_AUTOCOMPLETE_FAILED',
  SOCURE_AUTOCOMPLETE_SUCCESS: 'FIELD_SOCURE_AUTOCOMPLETE_SUCCESS',
  SOCURE_RETRIEVE_INFORMATION: 'FIELD_SOCURE_RETRIEVE_INFORMATION',
  VALIDATE: 'FIELD_VALIDATE',
  VALIDATE_SUCCESS: 'FIELD_VALIDATE_SUCCESS',

  atomicFiGetToken: (payload) => ({
    payload,
    type: fieldActions.ATOMICFI_GET_TOKEN,
  }),

  atomicFiGetTokenFailed: (payload) => ({
    payload,
    type: fieldActions.ATOMICFI_GET_TOKEN_FAILED,
  }),

  atomicFiGetTokenSuccess: (payload) => ({
    payload,
    type: fieldActions.ATOMICFI_GET_TOKEN_SUCCESS,
  }),

  atomicFiUpdateSwitchAttempts: (payload) => ({
    payload,
    type: fieldActions.ATOMICFI_UPDATE_SWITCH_ATTEMPTS,
  }),

  blur: (payload) => ({
    payload,
    type: fieldActions.BLUR,
  }),

  fetchAutoComplete: (fieldId, query, fieldName) => ({
    payload: {
      fieldName,
      request: () => axios.get(`${FIELDS_ROOT}/${fieldId}/autocomplete/${query}`),
    },
    type: fieldActions.FETCH_AUTOCOMPLETE,
  }),

  fetchSuccess: (data, fieldName) => ({
    payload: { data, fieldName },
    type: fieldActions.FETCH_AUTOCOMPLETE_SUCCESS,
  }),
  focus: (fieldName) => ({
    payload: { fieldName },
    type: fieldActions.SET_FOCUS,
  }),
  googlePlacesAutocomplete: (clientIdPrefix, data, clientIdIndex) => ({
    payload: {
      clientIdIndex,
      clientIdPrefix,
      data,
    },
    type: fieldActions.GOOGLE_PLACES_AUTOCOMPLETE,
  }),
  googlePlacesAutocompleteFailed: (payload) => ({
    payload,
    type: fieldActions.GOOGLE_PLACES_AUTOCOMPLETE_FAILED,
  }),
  googlePlacesAutocompleteSuccess: () => ({
    type: fieldActions.GOOGLE_PLACES_AUTOCOMPLETE_SUCCESS,
  }),
  reRender: (fieldName) => ({
    payload: {
      fieldName,
      request: (pageName, data) => () =>
        axios.put(`${PAGES_ROOT}/${pageName}/actions/rerender/${fieldName}`, data),
    },
    type: fieldActions.RERENDER,
  }),

  reRenderFailed: (data, forceUpdate) => ({
    payload: { data, forceUpdate, msgs: data.result && data.result.msgs },
    type: fieldActions.RERENDER_FAILED,
  }),
  reRenderSuccess: (data, forceUpdate) => ({
    payload: { data, forceUpdate },
    type: fieldActions.RERENDER_SUCCESS,
  }),
  setError: (fieldName, errorMsg) => ({
    payload: { errorMsg, fieldName },
    type: fieldActions.SET_ERROR,
  }),
  socureAutocomplete: (data) => ({
    payload: {
      data,
    },
    type: fieldActions.SOCURE_AUTOCOMPLETE,
  }),
  socureAutocompleteFailed: (payload) => ({
    payload,
    type: fieldActions.SOCURE_AUTOCOMPLETE_FAILED,
  }),
  socureAutocompleteSuccess: () => ({
    type: fieldActions.SOCURE_AUTOCOMPLETE_SUCCESS,
  }),
  socureRetrieveInformation: (referenceId) => ({
    payload: {
      referenceId,
    },
    type: fieldActions.SOCURE_RETRIEVE_INFORMATION,
  }),
  validate: (fieldName, withReRender = true, listGroupName = null, listIndex = null) => ({
    payload: {
      fieldName,
      listGroupName,
      listIndex,
      withReRender,
    },
    type: fieldActions.VALIDATE,
  }),

  validateSuccess: (fieldName) => ({
    payload: { fieldName },
    type: fieldActions.VALIDATE_SUCCESS,
  }),
};

export default fieldActions;
